'use client';

import React from 'react';
import classes from '@/components/shop/shop-home.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { setShopTabName } from '@/slice/shopSlice';

function ShopTab({
  dict: { ing, end },
}: {
  dict: { ing: string; end: string };
}) {
  const dispatch = useDispatch();
  const shopTabName = useSelector((state: RootState) => state.shop.tabName);

  const handleChangeShopTabName = (newName: 'ing' | 'end' | 'all') => {
    dispatch(setShopTabName(newName));
  };

  return (
    <ul>
      <li>
        <button
          className={`${classes.tabsBtn} ${shopTabName === 'all' && classes.active}`}
          onClick={() => handleChangeShopTabName('all')}
        >
          ALL
        </button>
      </li>
      <li>
        <button
          className={`${classes.tabsBtn} ${shopTabName === 'ing' && classes.active}`}
          onClick={() => handleChangeShopTabName('ing')}
        >
          {ing}
        </button>
      </li>
      <li>
        <button
          className={`${classes.tabsBtn} ${shopTabName === 'end' && classes.active}`}
          onClick={() => handleChangeShopTabName('end')}
        >
          {end}
        </button>
      </li>
    </ul>
  );
}

export default ShopTab;
